import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import { useVModel } from "@/hooks";
import TextInput from "./TextInput.vue";


/**
 * An input for email addresses.
 */
const __default__ = {
  name: "EmailInput",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modelValue: {},
    errorMessage: { type: [String, Boolean] },
    label: {}
  },
  emits: ["update:modelValue", "update:errorMessage", "enter"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const model = useVModel(props, "modelValue");

const errorMessage = computed(() => {
  if (
    model.value &&
    !/^\w+([+.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(model.value)
  ) {
    const error = "E-mail must contain a valid domain.";
    emit("update:errorMessage", error);
    return error;
  } else {
    emit("update:errorMessage", false);
    return props.errorMessage;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TextInput, {
    modelValue: _unref(model),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) ? (model).value = $event : null)),
    label: props.label || 'Email',
    "error-message": errorMessage.value,
    onEnter: _cache[1] || (_cache[1] = ($event: any) => (emit('enter')))
  }, null, 8, ["modelValue", "label", "error-message"]))
}
}

})